import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { useAccesos } from '../contexts/AccesosContext';
import { useUser } from '../contexts/UserContext';
import AperturaCajaDirecta from '../Arqueos/AperturaCajaDirecta'; // Nuevo componente
import { useSucursal } from '../contexts/SucursalContext';

const SideNav = () => {
  const rightColRef = useRef(null);
  const bodyRef = useRef(document.body);
  const sidebarMenuRef = useRef(null);
  const navMenuRef = useRef(null);
  const footerRef = useRef(null);
  const sidebarFooterRef = useRef(null);
  const menuToggleRef = useRef(null);
  const { accesos, menuTree } = useAccesos();
  const { user } = useUser();
  const { cajaAbierta, actualizarCajaAbierta } = useSucursal();
  // Estado para controlar el modal de caja
  const [isModalOpen, setModalOpen] = useState(false);

  // Funciones para abrir/cerrar el modal
  const handleOpenModal = () => {
    // Verificar si la caja ya está abierta antes de mostrar el modal
    if (cajaAbierta) {
      alert('La caja ya está abierta para este usuario.');
      return;
    }
    setModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setModalOpen(false);
    // Actualizar el estado de la caja después de cerrar el modal
    actualizarCajaAbierta();
  };

  useEffect(() => {
    const $RIGHT_COL = $(rightColRef.current);
    const $BODY = $(bodyRef.current);
    const $SIDEBAR_MENU = $(sidebarMenuRef.current);
    const $NAV_MENU = $(navMenuRef.current);
    const $FOOTER = $(footerRef.current);
    const $SIDEBAR_FOOTER = $(sidebarFooterRef.current);
    const $MENU_TOGGLE = $(menuToggleRef.current);
    const CURRENT_URL = window.location.href;

    const setContentHeight = () => {
      $RIGHT_COL.css('min-height', $(window).height());

      const bodyHeight = $BODY.outerHeight();
      const footerHeight = $BODY.hasClass('footer_fixed') ? -10 : $FOOTER.height();
      const leftColHeight = $SIDEBAR_FOOTER.height();
      const contentHeight = Math.max(bodyHeight, leftColHeight) - $NAV_MENU.height() - footerHeight;

      $RIGHT_COL.css('min-height', contentHeight);
    };

    const openUpMenu = () => {
      $SIDEBAR_MENU.find('li').removeClass('active active-sm');
      $SIDEBAR_MENU.find('li ul').slideUp();
    };

    $SIDEBAR_MENU.find('a').on('click', function (ev) {
      const $li = $(this).parent();

      if ($li.is('.active')) {
        $li.removeClass('active active-sm');
        $('ul:first', $li).slideUp(() => {
          setContentHeight();
        });
      } else {
        if (!$li.parent().is('.child_menu')) {
          openUpMenu();
        } else {
          if ($BODY.is('nav-sm')) {
            if (!$li.parent().is('child_menu')) {
              openUpMenu();
            }
          }
        }

        $li.addClass('active');
        $('ul:first', $li).slideDown(() => {
          setContentHeight();
        });
      }
    });

    $MENU_TOGGLE.on('click', () => {
      if ($BODY.hasClass('nav-md')) {
        $SIDEBAR_MENU.find('li.active ul').hide();
        $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
      } else {
        $SIDEBAR_MENU.find('li.active-sm ul').show();
        $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
      }

      $BODY.toggleClass('nav-md nav-sm');
      setContentHeight();

      $('.dataTable').each(function () {
        $(this).dataTable().fnDraw();
      });
    });

    $SIDEBAR_MENU
      .find('a[href="' + CURRENT_URL + '"]')
      .parent('li')
      .addClass('current-page');

    $SIDEBAR_MENU.find('a').filter(function () {
      return this.href === CURRENT_URL;
    })
      .parent('li')
      .addClass('current-page')
      .parents('ul')
      .slideDown(() => {
        setContentHeight();
      })
      .parent()
      .addClass('active');

    $(window).on('resize', setContentHeight);
    setContentHeight();

    if ($.fn.mCustomScrollbar) {
      $('.menu_fixed').mCustomScrollbar({
        autoHideScrollbar: true,
        theme: 'minimal',
        mouseWheel: { preventDefault: true }
      });
    }

    return () => {
      $(window).off('resize', setContentHeight);
      $SIDEBAR_MENU.find('a').off('click');
      $MENU_TOGGLE.off('click');
    };
  }, []);

  // Actualiza cajaAbierta al montar o al hacer clic en un botón:
  useEffect(() => {
    actualizarCajaAbierta();
  }, [actualizarCajaAbierta]);

  // Función recursiva para renderizar el árbol de menús dinámicamente
  const renderMenuTree = (nodes) => {
    if (!Array.isArray(nodes) || nodes.length === 0) return null;

    return nodes
      .filter((node) => node.estado !== false)
      .map((node) => {
        const hasChildren = node.children && node.children.length > 0;

        // Filtrar iconos inválidos (ej: 'fa' solo sin clase de ícono)
        const validIcon = node.icono_menu && node.icono_menu.trim().length > 2 ? node.icono_menu : null;

        // Caso especial: Iniciar Caja abre modal
        if (node.nombre_menu === 'Iniciar Caja') {
          return (
            <li key={node.id}>
              <a onClick={handleOpenModal} style={{ cursor: 'pointer' }}>
                <i className="fa fa-calculator" style={{ marginRight: '8px' }} />
                Iniciar Caja
              </a>
            </li>
          );
        }

        if (hasChildren) {
          // Menú con hijos (desplegable)
          const hasSelfChild = node.children.some(c => c.nombre_menu === node.nombre_menu);
          const selfLink = (node.href && !hasSelfChild) ? (
            <li key={`${node.id}-self`}>
              <Link to={node.href}>{node.nombre_menu}</Link>
            </li>
          ) : null;
          return (
            <li key={node.id}>
              <a href="#" onClick={(e) => e.preventDefault()}>
                {validIcon && <i className={validIcon} />} {node.nombre_menu}{' '}
                <span className="fa fa-chevron-down" />
              </a>
              <ul className="nav child_menu">
                {selfLink}
                {renderMenuTree(node.children)}
              </ul>
            </li>
          );
        } else {
          // Menú sin hijos (enlace directo)
          return (
            <li key={node.id}>
              <Link to={node.href || '#'}>
                {validIcon && <i className={validIcon} />} {node.nombre_menu}
              </Link>
            </li>
          );
        }
      });
  };

  return (
    <div className="App">
      <div className="col-md-3 left_col">
        <div className="left_col scroll-view">
          <div className="clearfix" />
          {/* Menu profile quick info */}
          <div className="profile clearfix">
            <div className="profile_pic">
              <img src="./images/avatar_index.jpg" alt="..." className="img-circle profile_img" />
            </div>
            <div className="profile_info">
              <span>Bienvenido,</span>
              <h2>{user.nombreCompleto} </h2>
            </div>
          </div>
          <br />
          {/* Sidebar menu */}
          <div id="sidebar-menu" className="main_menu_side hidden-print main_menu" ref={sidebarMenuRef}>
            <div className="menu_section">
              {/* Indicador de caja */}
              <span
                style={{
                  marginLeft: '10px',
                  color: cajaAbierta ? 'lightgreen' : 'inherit',
                  fontWeight: cajaAbierta ? 'bold' : 'normal'
                }}
              >
                {cajaAbierta ? 'Caja Abierta' : 'Caja Cerrada'}
              </span>
              <h3>Menu de Opciones</h3>
              <ul className="nav side-menu">
                {renderMenuTree(menuTree)}
              </ul>
            </div>
          </div>
          {/* /sidebar menu */}
          <div className="sidebar-footer hidden-small" ref={sidebarFooterRef}>
            <a href="#" data-toggle="tooltip" data-placement="top" title="Configuracion" onClick={(e) => e.preventDefault()}>
              <span className="glyphicon glyphicon-cog" aria-hidden="true" />
            </a>
            <a href="#" data-toggle="tooltip" data-placement="top" title="Reportar Problema" onClick={(e) => e.preventDefault()}>
              <span className="glyphicon glyphicon-eye-close" aria-hidden="true" />
            </a>
            <a data-toggle="tooltip" data-placement="top" title="Salir" href="login.html">
              <span className="glyphicon glyphicon-off" aria-hidden="true" />
            </a>
          </div>
          {/* /menu footer buttons */}
        </div>
      </div>
      <AperturaCajaDirecta open={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default SideNav;
